import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoXmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m19.404 13.992 6.182-7.8-2.807-3.552-.244-.307h-4.754l-3.732 4.845-3.78-4.845H5.4l-.6.76-2.466 3.083 6.15 7.8-6.15 7.75 2.725 3.618.244.323h4.868l3.797-4.845 3.862 4.845h5.143l2.694-3.876-6.264-7.8Zm-.91-10.044h2.045L16.16 9.81l-1.139-1.39 3.473-4.473ZM9.312 24.052H7.33l4.446-5.926 1.071 1.388-3.537 4.538Zm9.233 0-6.734-8.478-6.101 7.929-1.331-1.744 6.166-7.783-6.15-7.816 1.346-1.71 15.285 19.635-2.482-.032Zm4.007-.71L7.396 3.915h2.012l6.75 8.493 6.053-7.912 1.346 1.615-6.214 7.88 6.296 7.928-1.088 1.421Z",
		fill: "#fff"
	})
});
const ForwardRef = forwardRef(SvgLogoXmin);
export { ForwardRef as ReactComponent };
